export const specialCountries = {
  ppp1: [
    'PK',
    'EG',
    'TR',
    'CO',
    'BZ',
    'CU',
    'DM',
    'HT',
    'JM',
    'NI',
    'BL',
    'LC',
    'MF',
    'VC',
    'BO',
    'GY',
    'PY',
    'SR',
    'VE',
    'KE',
    'RU',
    'MA',
    'NG',
    'AR',
    'PH',
    'CV',
    'CF',
    'TD',
    'KM',
    'CD',
    'CG',
    'CI',
    'DJ',
    'GQ',
    'ER',
    'ET',
    'GA',
    'GM',
    'GH',
    'GW',
    'GN',
    'LS',
    'LR',
    'LY',
    'MG',
    'MW',
    'ML',
    'MR',
    'MU',
    'MZ',
    'NA',
    'NE',
    'RW',
    'SH',
    'ST',
    'SN',
    'SC',
    'SL',
    'SO',
    'SS',
    'SD',
    'SZ',
    'TZ',
    'TG',
    'UG',
    'ZM',
    'ZW',
    'BD',
    'BT',
    'KH',
    'CX',
    'IQ',
    'JO',
    'LA',
    'LB',
    'MN',
    'MM',
    'NP',
    'PS',
    'LK',
    'TL',
    'YE',
    'FJ',
    'KI',
    'PG',
    'PN',
    'WS',
    'SB',
    'TO',
    'TV',
    'VU',
    'WF',
    'AL',
    'BA',
    'BG',
    'HR',
    'MK',
    'ME',
    'RS',
    'SI',
    'UA',
    'BR',
    'ZA',
    'VN',
    'DO',
    'SV',
    'GT',
    'HN',
    'EC',
  ],
};
